// 年期文案只用于展示，可售项目和价格均由机构报价接口返回。
export const storageTerms = [
  { id: 1, name: "五年", term: "五年期" },
  { id: 2, name: "十年", term: "十年期" },
  { id: 3, name: "二十年", term: "二十年期" },
];

// 山一大 Logo 暂时隐藏，原素材和页面模板均保留。
// 快速恢复：将此开关改为 true，Logo、原始 Banner 和对应页面间距会一并恢复。
const showShandongUniversityLogo = false;

export const college = {
  '0': {
    'logo': require('@/assets/college/banner.png'),
    'loginLogo': require('@/assets/college/login-banner-logo.png'),
    'logoCard': require('@/assets/college/vip-card/logo.png'),
    'name': '山东药科大学'
  },
  '32': {
    'showLogo': showShandongUniversityLogo,
    // 原带 Logo 的 Banner 配置留存，统一通过上方开关恢复：
    // 'logo': require('@/assets/college/banner-32.png'),
    'logo': showShandongUniversityLogo
      ? require('@/assets/college/banner-32.png')
      : require('@/assets/college/bg-banner.png'),
    'loginLogo': require('@/assets/college/login-banner-logo-32.png'),
    'logoCard': require('@/assets/college/vip-card/logo-32.png'),
    'name': '山东第一医科大学'
  }
}
